import React, {createContext, useContext, useState} from 'react'
import PropTypes from 'prop-types'

const MiniCartContext = createContext()

export const MiniCartProvider = ({children}) => {
    const [shouldOpenMiniCart, setShouldOpenMiniCart] = useState(false)

    // MiniCart functions
    const openMiniCartOnAddToCart = () => {
        setShouldOpenMiniCart(true)
    }

    const onMiniCartOpened = () => {
        setShouldOpenMiniCart(false)
    }

    // MiniCart context value
    const miniCartContextValue = {
        openMiniCartOnAddToCart,
        shouldOpenMiniCart,
        onMiniCartOpened
    }

    return (
        <MiniCartContext.Provider value={miniCartContextValue}>{children}</MiniCartContext.Provider>
    )
}

MiniCartProvider.propTypes = {
    children: PropTypes.node.isRequired
}

// Custom hook to use the MiniCart context
export const useMiniCartContext = () => {
    const context = useContext(MiniCartContext)

    if (!context) {
        throw new Error('useMiniCartContext must be used within MiniCartProvider')
    }

    return context
}
